module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 2\"><path fill-rule=\"evenodd\" d=\"M0 0h10v2H0z\"></path></svg>"